<template>
    <div class="BeamPositionInfo mainWrap"><!--需要修添加class-->
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/BeamPositionInfo"></leftNav><!--改组件名-->
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
                <el-main>
                    <div class="mainWrao">
                        <div class="recordTitle">
                            <h1>{{$t('leftNav.navTwentyNine')}}</h1>
                            <div class="machineSeach">
                                <label style="margin-right:10px;font-size:12px;">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                                <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                            </div>
                        </div>
                        <!-- 页面主体部分-->
                        <div class="my">
                            <div class="tableWrap">
                                <div class="times">
                                    <el-date-picker
                                        v-model="datePicker"
                                        type="datetimerange"
                                        :editable="editable"
                                        @change="changeTime"
                                        :picker-options="pickerOptions"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        range-separator="~"
                                        :start-placeholder="$t('MachineDashBoard.StartTime')"
                                        :end-placeholder="$t('MachineDashBoard.EndTime')"
                                        align="left"
                                        :clearable='false'
                                        >
                                    </el-date-picker>
                                    <el-select 
                                        v-model="beltvalue" 
                                        @change="getBeltcode(beltvalue)" 
                                        class="beltCode" 
                                        filterable 
                                        :placeholder="$t('BeamPositionInfo.selectPlacehoder')"
                                        >
                                        <el-option
                                            v-for="(item,index) in beltList"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <el-button type="primary" style="float:right;" icon="el-icon-view" @click="showBtn()">{{$t('StepCycleTime.showBtn')}}</el-button>
                            </div>
                            <div id="myecharts" v-loading="myecharts" v-show="isData"></div>
                        </div>
                    </div>
                </el-main>
            </el-scrollbar>
        </el-container>
    </div>
</template>

<script>
import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"

export default {
  name: 'BeamPositionInfo',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
        // 选中的机械id
        machineID: [],
        //  模拟数据
        options: [],
        //带束下拉选项列表
        beltList:[],
        myChart:null,
        //选择的带束
        beltvalue:'',
        beltLabel:'',
        //选择的时间
        datePicker:[],
        pickerMinDate: '',
        //选中的时间开始时间与结束时间
        startTimePicker:'',
        endTimePicker:'',
        editable:false,
        pickerOptions: {
            onPick: ({minDate}) => {
                this.pickerMinDate = minDate.getTime()
            },
            disabledDate: (time) =>{
                if (this.pickerMinDate !== '') {
                    const day1 = 1 * 24 * 3600 * 1000
                    let maxTime = this.pickerMinDate + day1
                    let minTime = this.pickerMinDate - day1
                    return (time.getTime() > maxTime ||
                            time.getTime() < minTime)
                }
            },
            shortcuts: [{
                text: this.$t('MachineDashBoard.pickTime6'),
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 0.5);
                    picker.$emit('pick', [start, end]);
                }
            },
            {
                text: this.$t('MachineDashBoard.pickTime1'),
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 1);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: this.$t('MachineDashBoard.pickTime2'),
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 3);
                    picker.$emit('pick', [start, end]);
                }
            }]
        },
        myecharts:false,//echarts图表
        //x轴坐标
        xAxisList:[],
        //左值
        leftList:[],
        //右值
        rightList:[],
        //图表标题
        chartTitle:'',
        chartLeft:'',
        chartRight:'',
        isData:'',
        //选择日期范围是否超过一天
        maxData:false
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.getTime()
    //获取带束下拉列表
    this.getBeltList()
  },
  destroyed() {
  },
  methods: {
    getTime(){
        let _this = this
        this.axios({
            method: 'POST',
            url: '/url/getServerTime'
        }).then(function (res) {
            let timestamp=res.data
            let oldTimestamp = timestamp - 3600000
            let nowDate = formatDate(new Date(timestamp), 'yyyy-MM-dd hh:mm:ss')
            let oldDate = formatDate(new Date(oldTimestamp), 'yyyy-MM-dd hh:mm:ss')
            let dateArr = [oldDate,nowDate]
            _this.datePicker = dateArr
            _this.startTimePicker = dateArr[0]
            _this.endTimePicker = dateArr[1]
        })
    },
    // 切换计算周期的时间
    changeTime(){
        if (this.datePicker === null) {
            this.startTimePicker=''
            this.endTimePicker=''
            this.pickerMinDate = ''
        }else if(this.datePicker!=null){
            let startTime=Date.parse(new Date(this.datePicker[0]))
            let endTime=Date.parse(new Date(this.datePicker[1]))
            if(endTime-startTime>86400000){
                this.maxData=true
            }else{
                this.maxData=false
                this.startTimePicker=this.datePicker[0]
                this.endTimePicker=this.datePicker[1]
            }
        }
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
            // _this.noMachine=false
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }else{
            _this.options = res.data.options
            // _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 切换设备
    getchange(value){
        this.machineID[0]=Number(this.$store.state.defaultFactoryId)
        this.machineID[1]=Number(value)
    },
    //动态获取带束下拉选选项
    getBeltList(){
        let _this = this
        this.axios({
            method:'get',
            url:'url/getBelts',
            params:{
                language:_this.$store.state.lang
            }
        }).then(function(res){
            let belts=[]
            Object.keys(res.data).map(key => {
                let object={"label":key,"value":res.data[key]}
                belts.push(object)
            })
            _this.beltList=belts
        })
    },
    //切换带束赋值
    getBeltcode(val){
        this.beltvalue = val
        this.beltList.forEach(element => {
            if(this.beltvalue==element.value)this.beltLabel=element.label
        });
    },
    //查询
    showBtn(){
        if(this.myChart != null)this.myChart.clear()
        let id = this.machineID
        let belt = this.beltvalue.length
        let startBol= this.startTimePicker==''||this.startTimePicker==null
        let endBol= this.endTimePicker==''||this.endTimePicker==null
        if (id.length === 0) this.$message.error(this.$t('BeamPositionInfo.error1'));
        else if (startBol || endBol) this.$message.error(this.$t('BeamPositionInfo.error2'));
        else if (belt === 0) this.$message.error(this.$t('BeamPositionInfo.error3'));
        else if(this.maxData==true)this.$message.error(this.$t('BeamPositionInfo.error4'))
        else this.getData()
    },
    //获取图表数据
    getData(){
        let _this = this
        if(this.$store.state.lang ===1){
            this.chartTitle = this.beltLabel+'左右值坐标'
            this.chartLeft = this.beltLabel+'左值'
            this.chartRight = this.beltLabel+'右值'
        }else{
            this.chartTitle = 'left and right coordinate of '+this.beltLabel
            this.chartLeft = 'left values of '+this.beltLabel
            this.chartRight = 'right values of '+this.beltLabel
        }
        this.axios({
            method:'get',
            url:'url/getBeltPositionInfo',
            params:{
                machine_id: this.machineID[1],
                startTime: this.startTimePicker,
                endTime: this.endTimePicker,
                beltCode: this.beltvalue,
                language: this.$store.state.lang,
            }
        }).then(function(res){
            if (res.data.success === true){
                console.log(res)
                _this.xAxisList = res.data.realValues
                _this.leftList = res.data.leftValues
                _this.rightList = res.data.rightValues
                _this.isData = true
                _this.$nextTick(function(){
                    _this.initChart()
                })
            }else{
                _this.isData = false
                if(_this.myChart != null)_this.myChart.clear()
                _this.$message.error(res.data.msg);
            }
        })
    },
    //生成图表
    initChart(){
        let _this = this
        _this.myChart = this.$echarts.init(document.getElementById('myecharts'),'dark');
        _this.myChart.setOption({
            title: {
                text: _this.chartTitle,
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                right:'auto',
                bottom:'0'
            },
            toolbox: {
                show: true,
                feature: {
                dataZoom: {
                    yAxisIndex: 'none'
                },
                // dataView: { readOnly: false },
                // magicType: { type: ['line', 'bar'] },
                restore: {},
                saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: _this.xAxisList,
                axisLine: {
                    lineStyle: {
                        color: '#707070'
                    }
                },
            },
            yAxis: {
                type: 'value',
                max: 200,
                min: -200,
                axisLabel: {
                    formatter: '{value}'
                },
                axisLine: {
                    lineStyle: {
                        color: '#707070'
                    }
                },
            },
            series: [
                {
                    name: _this.chartRight,
                    type: 'line',
                    data: _this.rightList,
                    markLine: {
                        // data: [{ type: 'average', name: 'Avg' }]
                    },
                    symbolSize: 4,
                    lineStyle:{
                        width: 1
                    },
                    itemStyle : {  
                        normal : {  
                            color:'#61b091',
                            lineStyle:{  
                                color:'#61b091'  
                            }  
                        }  
                    }, 
                },
                {
                    name: _this.chartLeft,
                    type: 'line',
                    data: _this.leftList,
                    markLine: {
                        data: [
                        // { type: 'average', name: 'Avg' }
                        ]
                    },
                    symbolSize: 4,
                    lineStyle:{
                        width: 1
                    },
                    itemStyle : {  
                        normal : {  
                            color:'#4385dc',
                            lineStyle:{  
                                color:'#4385dc'  
                            }  
                        }  
                    }, 
                }
            ]
        })
    }, 
  }
}
</script>
<style scoped>
.BeamPositionInfo{
    min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
    height: 100%;
    width: 100%;
    background-color: #f6f9fc;
    box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    border-radius: 4px;
}
.recordTitle{
    padding: 20px 25px;
    background-color: #fff;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 4px 4px 0 0;
    line-height: 35px;
}
.recordTitle h1{
    font-size: 20px;
    color: #525f7f;
    margin-bottom: 5px;
    display: inline-block;
}
.recordTitle .machineSeach{
    float: right;
    display:flex;
    align-items: center;
}
/* 我的样式 */
.my{
    height: 800px;
    width: 100%;
}
.my .tableWrap{
    box-sizing: border-box;
    display:flex;
    justify-content:space-between;
    align-items:center;
    width: 94%;
    margin: 0 auto;
    padding: 20px 0 15px 0;
}
.my .tableWrap .beltCode{
    margin-left: 30px;
}
#myecharts{
    width: 90%;
    height: 80%;
    padding: 27px 0 10px;
    margin:0 auto;
}
</style>

